module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.step.kind === 'multiple-choice' || _vm.step.kind === 'yes-no' || _vm.step.kind === 'welcome') ? _c('button', {
    staticClass: "klickbox-step-button",
    on: {
      "click": function($event) {
        _vm.stepSetActive(_vm.step);
        _vm.sidebarChangePanel('jump')
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-jump-o"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jumpCount(_vm.step.jumps)),
      expression: "jumpCount(step.jumps)"
    }],
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.jumpCount(_vm.step.jumps)))]), _vm._v(" "), _c('span', {
    staticClass: "step-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.destinations')))])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-76af3cb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/list/ButtonJump.vue
 ** module id = 864
 ** module chunks = 1
 **/